<template lang="pug">
  .panel-block(:class="{dark}")
    .header
      slot(name="header")
        label.title {{title}}
    .content
      slot
    .footer
      slot(name="footer")
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .panel-block
    display flex
    border-radius 4px
    background-color $white-color
    font-size 90%
    flex-direction column
    padding 10px 20px
    margin-top 20px
    &.dark
      color $white-color
      background-color $cyprus-color
    .header
      color $white-color
      font-weight 600
    .content
      display flex
      flex-direction column
    .header, .content
      padding 10px 0

</style>



// WEBPACK FOOTER //
// src/components/lei-components/PanelBlock.vue